import { render, staticRenderFns } from "./ChecklistsIndex.vue?vue&type=template&id=05cd3260"
import script from "./ChecklistsIndex.vue?vue&type=script&lang=js"
export * from "./ChecklistsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports